// import { Router } from "express";
import { createRouter, createWebHistory } from "vue-router";
import store from "./store";

// import pages
import LoginUser from "./components/pages/LoginUser.vue";
import RegisterUser from "./components/pages/RegisterUser.vue";
import HomePage from "./components/pages/HomePage.vue";
import UserProfile from "./components/pages/UserProfile.vue";
import DashBoard from "./components/pages/DashBoard";
import Clients from "./components/pages/clients";
import RegisterCourt from "./components/pages/RegisterCourt";
import RegisterClient from "./components/pages/RegisterClient";
import OutsideClient from "./components/pages/newClients";
import ReceivePayment from "./components/pages/ReceivePayments";
import Payments from "./components/pages/payments";
import MpesaPayments from "./components/pages/mpesaPayments";
import Messages from "./components/pages/messages";


import Reports from "./components/pages/reports";
import Courts from "./components/pages/courts";
import ClientPayments from "./components/pages/ClientPayments";
import courtPayments from "./components/pages/courtPayments";
import courtClients from "./components/pages/courtClients";
import RequestingClients from "./components/pages/requestingClients";
import SendMessages from "./components/pages/sendMessages";
import smsReport from "./components/pages/smsReport";
import clientInvoice from "./components/pages/clientInvoice";
import registerCorporateclient from "./components/pages/registerCorporateclient";
// import corporateClients from "./components/pages/corporateClients";
import copClients from "./components/pages/copClients";
import invoices from "./components/pages/invoices";
import createInvoice from "./components/pages/createInvoice";
import invoiceServices from "./components/pages/invoiceServices";
import createService from "./components/pages/createService";



import simpleSms from "./components/pages/simpleSms";
import editClient from "./components/pages/editClient"
// import store from './store'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: HomePage },
    { path: "/login", component: LoginUser, meta: { auth: false } },
    { path: "/register", component: RegisterUser, meta: { auth: false } },
    { path: "/profile", component: UserProfile, },
    { path: "/dashboard", component: DashBoard, meta: { auth: true }  },
    { path: "/apps", component: DashBoard, meta: { auth: true }  },


    
    { path: "/reports", component: Reports, meta: { auth: true }  },
    { path: "/sms/report", component: smsReport, meta: { auth: true }  },
    // { path: "/invoice/client", component: clientInvoice, meta: { auth: true }  },
    { path: "/invoice/:number", component: clientInvoice, meta: { auth: true }  },
    { path: "/create/invoice/:client", component: createInvoice, meta: { auth: true }  },
    { path: "/invoice/services/:number", component: invoiceServices, meta: { auth: true }  },
    { path: "/invoices/add_invoice_services/:number", component: createService, meta: { auth: true }  },

    {
      path: "/register/clients",
      component: RegisterClient,
      meta: { auth: true }
    },
    { path: "/clients", component: Clients, meta: { auth: true } },
    { path: "/register/court", component: RegisterCourt, meta: { auth: true } },
    {path: "/new/client/registration", component: OutsideClient, meta: { auth: true } },
    { path: "/courts", component: Courts, meta: { auth: true }  },
    { path: "/requesting/clients", component: RequestingClients },
    {path: "/corporate/client/registration", component: registerCorporateclient, meta: { auth: true } },
    {path: "/corporate/clients", component: copClients, meta: { auth: true } },
    {path: "/invoices/client/:client", component: invoices, meta: { auth: true } },

    { path: "/messages", component: Messages, meta: { auth: true }  },

    { path: "/send/sms", component: SendMessages, meta: { auth: true }  },
    { path: "/send/simple/sms", component: simpleSms, meta: { auth: true }  },
    {
      path: "/receive/payment",
      component: ReceivePayment,
      meta: { auth: true }
    },
    { path: "/payments", component: Payments, meta: { auth: true } },
    { path: "/mpesa/payments", component: MpesaPayments, meta: { auth: true } },
    { path: "/client/payments/:client", component: ClientPayments, meta: { auth: true }  },
    { path: "/court/payments/:court", component: courtPayments, meta: { auth: true }  },
    { path: "/court/clients/:court", component: courtClients, meta: { auth: true }, props:true },
    { path: "/edit/client/:client", component: editClient, meta: { auth: true }  },



  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn) {
      next({ path: '/Login' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router;
